// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Title = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Title = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Title = _exports.Title = function Title(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M4.12203 4H15.8881L16 7.08192H15.5017C15.2576 6.11365 14.9458 5.48487 14.5661 5.19557C14.1932 4.90037 13.4034 4.75277 12.1966 4.75277H11.0373V14.0339C11.0373 14.7365 11.1627 15.1734 11.4136 15.3446C11.6644 15.51 12.2136 15.6192 13.061 15.6723V16H6.98983V15.6723C7.87119 15.6133 8.42034 15.4863 8.63729 15.2915C8.85424 15.0967 8.96271 14.6066 8.96271 13.8214V4.75277H7.80339C6.65085 4.75277 5.86441 4.89742 5.44407 5.18672C5.03051 5.47602 4.71864 6.10775 4.50848 7.08192H4L4.12203 4Z",
      fill: "#212B36"
    }));
  };
});
